var _g, _mask, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMcloudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 313,
    fill: "none",
    viewBox: "0 0 420 313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_15_8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320.082,
    cy: 87.5,
    r: 87.5,
    fill: "url(#paint0_linear_15_8)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_15_8",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M319.761 313L150.358 313C67.3176 313 0 245.843 0 163C0 80.1573 67.3176 13 150.358 13C217.131 13 273.738 56.4226 293.354 116.507C301.767 114.22 310.621 113 319.761 113C375.122 113 420 157.771 420 213C420 268.228 375.122 313 319.761 313Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_15_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_15_8)",
    fillRule: "evenodd",
    d: "M319.761 313L150.358 313C67.3176 313 0 245.843 0 163C0 80.1573 67.3176 13 150.358 13C217.131 13 273.738 56.4226 293.354 116.507C301.767 114.22 310.621 113 319.761 113C375.122 113 420 157.771 420 213C420 268.228 375.122 313 319.761 313Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M150.358 313V312V313ZM319.761 313V314V313ZM293.354 116.507L292.403 116.817L292.698 117.721L293.616 117.472L293.354 116.507ZM150.358 314L319.761 314V312L150.358 312V314ZM-1 163C-1 246.397 66.7675 314 150.358 314V312C67.8676 312 1 245.288 1 163H-1ZM150.358 12C66.7675 12 -1 79.6027 -1 163H1C1 80.7118 67.8676 14 150.358 14V12ZM294.304 116.196C274.558 55.7118 217.575 12 150.358 12V14C216.687 14 272.918 57.1334 292.403 116.817L294.304 116.196ZM293.616 117.472C301.945 115.208 310.711 114 319.761 114V112C310.532 112 301.59 113.232 293.091 115.542L293.616 117.472ZM319.761 114C374.572 114 419 158.326 419 213H421C421 157.217 375.672 112 319.761 112V114ZM419 213C419 267.674 374.572 312 319.761 312V314C375.672 314 421 268.783 421 213H419Z",
    mask: "url(#path-2-inside-1_15_8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_15_8",
    width: 175,
    height: 195,
    x: 232.582,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "overlay",
    result: "effect1_innerShadow_15_8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_15_8",
    width: 420,
    height: 348.647,
    x: 0,
    y: 13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_15_8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_8",
    x1: 320.082,
    x2: 320.082,
    y1: 0,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_8",
    x1: 29.423,
    x2: 419.459,
    y1: 13,
    y2: 313.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcloudy);
export default __webpack_public_path__ + "static/media/mcloudy.9926ba6d4ab81ca80ca73ebb5c70765f.svg";
export { ForwardRef as ReactComponent };